import { apiClient } from "./apiClient";
import {
  CardapioFormData,
  CardapioItem,
  PaginatedCardapioResponse,
} from "../types/cardapio";

export const cardapioService = {
  getSabores: async (): Promise<CardapioItem[]> => {
    return apiClient.get("/cardapio");
  },

  getSaboresPaginated: async (
    page: number,
    limit: number,
    search?: string,
    ingrediente?: string
  ): Promise<PaginatedCardapioResponse> => {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });
    if (search?.trim()) params.set("search", search.trim());
    if (ingrediente?.trim()) params.set("ingrediente", ingrediente.trim());
    return apiClient.get(`/cardapio?${params.toString()}`);
  },

  createSabor: async (data: CardapioFormData): Promise<CardapioItem> => {
    const formData = new FormData();
    formData.append("nome", data.nome);
    formData.append("tipo", data.tipo);
    formData.append("ingredientes", JSON.stringify(data.ingredientes));
    if (data.foto) {
      formData.append("foto", data.foto);
    }
    const response = await fetch(
      `${process.env.REACT_APP_API_URL || "http://localhost:3001"}/cardapio`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: formData,
      }
    );
    if (!response.ok) {
      throw new Error("Erro ao cadastrar sabor");
    }
    return response.json();
  },

  updateSabor: async (
    id: number,
    data: CardapioFormData
  ): Promise<CardapioItem> => {
    const formData = new FormData();
    formData.append("nome", data.nome);
    formData.append("tipo", data.tipo);
    formData.append("ingredientes", JSON.stringify(data.ingredientes));
    if (data.foto) {
      formData.append("foto", data.foto);
    }
    const response = await fetch(
      `${process.env.REACT_APP_API_URL || "http://localhost:3001"}/cardapio/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: formData,
      }
    );
    if (!response.ok) {
      throw new Error("Erro ao atualizar sabor");
    }
    return response.json();
  },

  deleteSabor: async (id: number): Promise<void> => {
    return apiClient.delete(`/cardapio/${id}`);
  },

  deleteSaborFoto: async (id: number): Promise<void> => {
    return apiClient.delete(`/cardapio/${id}/foto`);
  },
};
